module.exports = __webpack_public_path__ + "img/BeYou-Health-Bar-Design-Tashii-Designs2.4c4cbb88.jpg";